<p class="card-entities__title" *ngIf="title">{{ title }}</p>
<div class="card-entities">
  <div
    class="card-entity"
    *ngFor="let item of items; trackBy: trackEntity"
    role="button"
    tabindex="0"
    [attr.aria-label]="(item.kind === 'contact' ? 'Open contact' : 'Open account') + ': ' + item.label + (item.sublabel ? ', ' + item.sublabel : '')"
    (click)="onEntityTap(item)"
    (keydown)="onEntityKeydown($event, item)">
    <ion-icon class="card-entity__icon" [name]="entityIcon(item.kind)" aria-hidden="true"></ion-icon>
    <div class="card-entity__text">
      <span class="card-entity__label">{{ item.label }}</span>
      <span class="card-entity__sublabel" *ngIf="item.sublabel">{{ item.sublabel }}</span>
    </div>
    <ion-icon class="card-entity__chevron" name="chevron-forward-outline" aria-hidden="true"></ion-icon>
  </div>
</div>
